/* ---------------------------------------
Textyle.js - v2.0
--------------------------------------- */
(function ($) {
	$.fn.textyle = function (options) {
		var target = this;
		var targetTxt = target.contents();
		var defaults = {
			duration: 400,
			delay: 100,
			easing: 'swing',
			callback: null
		};
		var setting = $.extend(defaults, options);
		targetTxt.each(function () {
			var texts = $(this);
			if (this.nodeType === 3) {
				mkspn(texts);
			}
		});
		function mkspn(texts) {
			texts.replaceWith(texts.text().replace(/(\S)/g, '<p>$1</p>'));
		}
		return this.each(function () {
			var len = target.children().length;
			target.css('opacity', 1);
			for (var i = 0; i < len; i++) {
				target.children('p:eq(' + i + ')')
					.delay(setting.delay * i)
					.animate({
						opacity: 1,
						top: 0,
						left: 0,
					}, setting.duration, setting.easing, setting.callback);
			};
		});
	};
}(jQuery));

(function ($) {
	/* ---------------------------------------
		全画面表示
	--------------------------------------- */
	$(document).ready(function () {
		var windowHeight = $(window).height();
		$('.wh_cover').height(windowHeight);
	});

	/* ---------------------------------------
	slick
--------------------------------------- */
	function mv_slider() {
		$('.home_main_visual-slider').slick({
			autoplay: true,
			autoplaySpeed: 5500,
			pauseOnHover: false,
			pauseOnFocus: false,
			arrows: false,
			dots: true,
			infinite: true,
			fade: true,
			speed: 1200,
			customPaging: function (slider, i) {
				return $('<div class="num">').text('0' + (i + 1));
			}
		});
		$('.slick-dots').addClass('show');
	}

	/* ---------------------------------------
		homeのメニューカラム落ち防止サイズ以上の場合openを付与
	--------------------------------------- */
	$(window).on('load', function () {
		var windowWidth = window.innerWidth;
		if (windowWidth > 1000) {
			$('.home .header').addClass('open');
			$('.home .nav_btn').addClass('active');
		}
	});

	/* ---------------------------------------
		Wのロゴ
	--------------------------------------- */

	/* ---------------------------------------
		動画のフェードアウト main_visual
	--------------------------------------- */
	// var cookie = $.cookie('mv_movie');
	// if (!cookie) {
	// 	$('html,body').animate({ scrollTop: 0 }, '1');
	// 	$('body').addClass('playing');
	// 	$('head').addClass('delay-1s');
	// 	var mvw = $('.home_main_visual-movie_wrap');
	// 	var mv = $('.home_main_visual-movie');
	// 	var mvg = $('.home_main_visual-movie').get(0);
	// 	mvg.pause();
	// 	$(window).on('load', function () {
	// 		mvw.show();
	// 		$('body').removeClass('fadeout');
	// 		mv.delay(1000).queue(function (next) {
	// 			mvg.play();
	// 			next();
	// 		});
	// 		mv.on('ended', function () {
	// 			var slideTextH = $('.textyle').outerHeight();
	// 			$('.slide_logo').outerHeight(slideTextH);
	// 			$(this).parent().fadeOut(2000);
	// 			$('.textyle_text').delay(2000).queue(function () {
	// 				$(this).textyle({
	// 					duration: 1000,
	// 					delay: 60,
	// 					easing: 'swing'
	// 				});
	// 				setTimeout(function () {
	// 					$('.textyle_logo').css('opacity', '1');
	// 				}, 1000);
	// 				setTimeout(function () {
	// 					$('.textyle').addClass('move');
	// 				}, 2000);
	// 				setTimeout(function () {
	// 					$('.textyle_text').css('opacity', '0');
	// 				}, 3500);
	// 				setTimeout(function () {
	// 					$('.slide_logo').fadeIn(600).css('display', 'flex');
	// 				}, 3500);
	// 				setTimeout(function () {
	// 					$('.textyle_logo').css('opacity', '');
	// 				}, 4500);
	// 			});
	// 			$('body').delay(4500).queue(function () {
	// 				$(this).removeClass('playing');
	// 				$(this).addClass('ended');
	// 				setTimeout(mv_slider, 1800);
	// 			});
	// 		});
	// 	});
	// 	$.cookie('mv_movie', 1, { expires: 1 });
	// } else {
	$('body').removeClass('fadeout');
	$(window).on('load', function () {
		var slideTextH = $('.textyle').outerHeight();
		$('.slide_logo').outerHeight(slideTextH).hide();
		$('.textyle_text').textyle({
			duration: 500,
			delay: 20,
			easing: 'swing'
		});
		setTimeout(function () {
			$('.textyle_logo').css('opacity', '1');
		}, 300);
		setTimeout(function () {
			$('.textyle').addClass('move');
		}, 1000);
		setTimeout(function () {
			$('.textyle_text').css('opacity', '0');
		}, 2000);
		setTimeout(function () {
			$('.slide_logo').fadeIn(2000).css('display', 'flex');
		}, 2000);
		setTimeout(function () {
			$('.textyle_logo').css('opacity', '');
		}, 3000);
		setTimeout(function () {
			mv_slider();
		}, 4000);
	});
	// }

	/* ---------------------------------------
	end
	--------------------------------------- */
})(jQuery);